import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box, Typography } from '@material-ui/core';

import { toAbsoluteUrl } from '../../../utils';

import styles from './styles';

const useStyles = makeStyles(styles);

const FeatureFlagAlert = ({ title, text, gutterTop, gutterBottom }) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.featureFlagAlertContainer}
      style={{
        marginTop: gutterTop !== undefined ? `${gutterTop}px` : undefined,
        marginBottom:
          gutterBottom !== undefined ? `${gutterBottom}px` : undefined,
      }}
    >
      <Box
        component="img"
        src={toAbsoluteUrl('/assets/icons/warning-triangle-outline.svg')}
        alt="Warning Triangle Outline Icon"
        className={classes.featureFlagAlertIcon}
      />

      <Box className={classes.featureFlagAlertContent}>
        {title && (
          <Typography
            variant="inherit"
            component="h6"
            className={classes.featureFlagAlertContentTitle}
          >
            {title}
          </Typography>
        )}

        <Typography
          variant="inherit"
          component="p"
          className={classes.featureFlagAlertContentText}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

FeatureFlagAlert.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  gutterTop: PropTypes.number,
  gutterBottom: PropTypes.number,
};

FeatureFlagAlert.defaultProps = {
  title: undefined,
  gutterTop: undefined,
  gutterBottom: undefined,
};

export default FeatureFlagAlert;
